module.exports = __webpack_public_path__ + "static/img/4418_phase_function_Paper_PointsHejduk_Prediction.cf2b5d7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/4418_phase_function_Paper_PointsHejduk_Prediction.png
// module id = FKXH
// module chunks = 0